import { useCallback, useLayoutEffect, useMemo, useState } from 'react';

const useWindowSize = () => {
    const [size, setSize] = useState({ width: 0, height: 0 });

    const updateSize = useCallback(() => {
        setSize({ width: window.innerWidth, height: window.innerHeight });
    }, []);

    useLayoutEffect(() => {
        window.addEventListener('resize', updateSize);
        updateSize();

        return () => {
            window.removeEventListener('resize', updateSize);
        };
    }, [updateSize]);

    return size;
};

export interface GridConfig {
    '2xl': number;
    'xl': number;
    'lg': number;
    'md': number;
    'sm': number;
    'default': number;
}

export const useGridCols = (config?: Partial<GridConfig>) => {
    const size = useWindowSize();

    return useMemo(() => {
        const breakpoints = {
            'default': 2,
            'sm': 3,
            'md': 4,
            'lg': 5,
            'xl': 5,
            '2xl': 6,
            ...config,
        } satisfies GridConfig;

        if (size.width >= 1536) return breakpoints['2xl'];
        if (size.width >= 1280) return breakpoints.xl;
        if (size.width >= 1024) return breakpoints.lg;
        if (size.width >= 768) return breakpoints.md;
        if (size.width >= 640) return breakpoints.sm;
        return breakpoints.default;
    }, [size.width, config]);
};
